import React, { useState, useEffect } from "react"; 
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory"; // Import Inventory Component
import ReceivingList from "./pages/ReceivingList"; // Import ReceivingList Component

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check authToken in localStorage to determine authentication state
    const token = localStorage.getItem("authToken");
    setIsAuthenticated(!!token);
  }, []);

  return (
    <Router>
      <Routes>
        {/* Login Route */}
        <Route
          path="/loginpage"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage setIsAuthenticated={setIsAuthenticated} />}
        />

        {/* Dashboard Route (Protected) */}
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Dashboard setIsAuthenticated={setIsAuthenticated} /> : <Navigate to="/loginpage" />}
        />

        {/* Inventory Route (Protected) */}
        <Route
          path="/Inventory"
          element={isAuthenticated ? <Inventory /> : <Navigate to="/loginpage" />}
        />

        {/* ReceivingList Route (Protected) */}
        <Route
          path="/Receiving"
          element={isAuthenticated ? <ReceivingList /> : <Navigate to="/loginpage" />}
        />

        {/* Redirect Unknown Routes */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/loginpage"} />} />
      </Routes>
    </Router>
  );
};

export default App;
